// extracted by mini-css-extract-plugin
export default {"container":"UrlInput-module__container--LefPr"};